module.exports = __webpack_public_path__ + "img/20250606_1.b0315bd1.jpg";